export default __webpack_public_path__ + "9e47bd47f702229251889b03b2ce5c17.svg";